const COLOR_DEFAULT = "#7a7468";
const COLOR_OK = "#b1b8b1";
const COLOR_ERR = "#C8A050";
export function addCopyButtons() {
    document
        .querySelectorAll("[data-copy-btn]")
        .forEach((btn) => {
        btn.addEventListener("click", async () => {
            const text = btn.dataset["copyValue"] ??
                btn.closest("div")?.querySelector("pre")?.textContent ??
                "";
            try {
                await navigator.clipboard.writeText(text);
                btn.textContent = "✔";
                btn.style.color = COLOR_OK;
            }
            catch {
                btn.textContent = "err";
                btn.style.color = COLOR_ERR;
            }
            setTimeout(() => {
                btn.textContent = "⧉";
                btn.style.color = COLOR_DEFAULT;
            }, 1500);
        });
    });
}
